export const AgruparEstadoResultados = (miArray, prop, grupo) => {
    if (miArray === undefined || miArray == null || miArray.lenght == 0) {
      return [];
    }
    var array = miArray.reduce(function (groups, item) {
      var val = item[prop];
      groups[val] = groups[val] || {
        display: item[prop],
        total: 0,
        proyectado: 0,
        totallast: 0,
        proyectadolast: 0
      }
      if (item.grupo == grupo) {
        groups[val].total += Number(item.total);
        groups[val].proyectado += Number(item.proyectado);
        groups[val].totallast += Number(item.totallast);
        groups[val].proyectadolast += Number(item.proyectadolast);
      }
      return groups;
    }, {})
    return Object.values(array);
  }